module.exports = __webpack_public_path__ + "static/media/be.851696cb.svg";